import React from "react";
import styles from "./CustomCheckbox.module.css";
import { useAppColors } from "@/hooks/contextHooks/useAppColors";
import { Text } from "@/components/Generics/Text";

export const CustomCheckbox = ({
  label,
  checked = false, // ✅ Default fallback
  onChange,
  disabled,
}: {
  label?: string;
  checked?: boolean; // ✅ Now optional
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
}) => {
  const { colors } = useAppColors();

  return (
    <label
      className={styles.label}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        style={{
          backgroundColor: checked ? colors.brand : colors.primary,
        }}
      />
      <Text>{label}</Text>
    </label>
  );
};
